module.exports = __webpack_public_path__ + "assets/ce95a3c41fe39025e4255434ef6605c9.svg";